module.exports = __webpack_public_path__ + "static/media/logo-verticale.ba9c32f5.svg";